import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-academy-badges',
  templateUrl: './academy-badges.component.html',
  styleUrls: ['./academy-badges.component.scss']
})
export class AcademyBadgesComponent implements OnInit {

  public modalOverlay: any;
  public modal: any;
  public searchTerm: string = '';

  constructor(private location: Location) { }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
     this.modalOverlay = document.getElementById('modal-overlay');
     this.modal = document.getElementById('modal');
  }

  public search(searchTerm: string): void {

  }

  public openModal(): void {
    this.modalOverlay.classList.add('flex');
    this.modal.classList.remove('animate-fade-out');
    this.modal.classList.add('animate-fade-in');
  }
  
  public closeModal() {
    this.modal.classList.remove('animate-fade-in');
    this.modal.classList.add('animate-fade-out');
    setTimeout(() => {
      this.modalOverlay.classList.remove('flex');
    }, 250);
  }
  
  public handleOverlayClick(event) {
    if (event.target === this.modalOverlay) {
      this.closeModal();
    }
  }

  public goBack(): void {
    this.location.back();
  }

}
